export { default } from './UpdateTableModal';
